// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3H0mi","large":"styles_large__2bbz_"};